import {
  Badge as MuiBadge,
  Checkbox as MuiCheckbox,
  MenuItem as MuiMenuItem,
  styled,
  Typography,
} from '@mui/material';

export const Badge = styled(MuiBadge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.accentColor.main,
    top: '7px',
    right: 0,
  },
}));

export const MenuItem = styled(MuiMenuItem, {
  shouldForwardProp: (prop) => prop !== 'isBordered',
})<{ isBordered?: boolean }>(({ theme, isBordered }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: isBordered ? `1px solid ${theme.palette.grey[600]}` : 'none',
}));

export const MenuItemLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible: boolean }>(({ theme, isVisible }) => ({
  position: 'relative',
  '&::after': {
    content: isVisible ? '""' : 'none',
    position: 'absolute',
    top: 8,
    right: -15,
    width: 7,
    height: 7,
    background: theme.palette.accentColor.main,
    borderRadius: 5,
  },
}));

export const Checkbox = styled(MuiCheckbox)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.accentColor.main,
  },
}));

export const MenuPaperProps = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 0.5,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
};
